<template>
  <div class="card mb-25 border-0 rounded-0 bg-white letter-spacing">
    <div class="card-header">
      <h5>{{ distribution.note_ref }}</h5>
      <br />
      <p>
        Date de création :
        <b v-if="distribution.created_at">
          {{ getDate(distribution.created_at) }}</b
        >
        | |<b> {{ distribution.zone_name }} </b> |
        <b>{{ distribution.note_city }} </b> |
        <b>{{ distribution.note_delivery_name }} </b>
      </p>
    </div>
  </div>

  <div class="card mb-25 border-0 rounded-0 bg-white letter-spacing">
    <div class="card-header">
      <h5>List des colis ajoutés</h5>
    </div>
    <div class="card-body p-15 p-sm-20 p-md-25">
      <div class="row">
        <div
          class="col-md-6 d-flex align-items-center justify-content-start mb-1 mb-md-0"
        >
          <label>Voir</label>
          <v-select
            v-model="users2.per_page"
            :options="[10, 25, 50, 100]"
            :clearable="false"
            class="per-page-selector d-inline-block mx-50"
            @update:modelValue="getRows2()"
          />
          <label>{{ users2.total }} entités</label>
        </div>

        <div class="col-12">
          <div class="custom-search d-flex justify-content-end">
            <div class="form-group">
              <div class="d-flex align-items-center">
                <input
                  placeholder="Chercher"
                  type="text"
                  @input="getRows2()"
                  v-model="users2.searchTerm"
                  class="form-control"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <vue-good-table
        :columns="columns2"
        :rows="rows2"
        :search-options="{
          enabled: true,
          externalQuery: users2.searchTerm,
        }"
        :select-options="{
          selectOnCheckboxOnly: true,
          enabled: true,
          clearSelectionText: 'Annuler',
          selectionText: 'Colis Sélectionés',
          disableSelectInfo: true,
        }"
        @select-all="onSelectAll"
        @selected-rows-change="selectionChanged"
      >
        <!-- <div slot="emptystate"></div> -->
        <template #emptystate>
          <center>Aucune entrées correspondants trouvés</center>
        </template>
        <template #table-row="props">
          <template v-if="props.column.field === 'code'">
            <h6 class="text-warning" v-if="props.row.replace == 1">
              {{ props.row.code }}
              <i class="flaticon-refresh"></i>
            </h6>
            <h6 class="text-info" v-else-if="props.row.partial == 1">
              {{ props.row.code }}
              <i class="flaticon-corner-down-left"></i>
            </h6>
            <h6 v-else>
              {{ props.row.code }}
            </h6>
          </template>
          <template v-else-if="props.column.field === 'c_statut'">
            <div
              v-if="
                props.row.status == 'IN_PROGRESS' &&
                props.row.status_second &&
                globalStore.globalHelper(props.row.status_second).name
              "
              class="rounded-pill fs-13 badge text-bg-black custom-badge"
              :style="{
                '--dynamic-bg': globalStore.globalHelper(
                  props.row.status_second
                ).code_color,
              }"
            >
              {{ globalStore.globalHelper(props.row.status_second).name }}
            </div>
            <div
              v-else
              class="rounded-pill fs-13 badge text-bg-black custom-badge"
              :style="{ '--dynamic-bg': props.row.code_color }"
            >
              {{ props.row.s_name }}
            </div>
          </template>

          <template v-else-if="props.column.field === 'actual_statut'">
            <div
              v-if="
                props.row.status == 'IN_PROGRESS' &&
                props.row.status_second &&
                globalStore.globalHelper(props.row.status_second).name
              "
              class="rounded-pill fs-13 badge text-bg-black custom-badge"
              :style="{
                '--dynamic-bg': globalStore.globalHelper(
                  props.row.status_second
                ).code_color,
              }"
            >
              {{ globalStore.globalHelper(props.row.status_second).name }}
            </div>
            <div
              v-else
              class="rounded-pill fs-13 badge text-bg-black custom-badge"
              :style="{ '--dynamic-bg': props.row.code_color }"
            >
              {{ props.row.s_name }}
            </div>
          </template>

          <template v-else-if="props.column.field === 'price'">
            <b>{{ props.row.price }}</b> {{ $devis }}
          </template>
          <template v-else-if="props.column.field === 'updated_at'">
            <span class="text-nowrap">
              {{ getDate(props.row.updated_at) }}
            </span>
          </template>

          <span v-else>
            {{ props.formattedRow[props.column.field] }}
          </span>
        </template>
      </vue-good-table>
      <div class="row">
        <div class="col-12">
          <div>
            <div class="col-12">
              <PaginatorContent
                :pagination="users2"
                :offset="9"
                @paginate="getRows2"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div
    class="card mb-25 border-0 rounded-0 bg-white letter-spacing"
    v-if="distribution.note_save == 0 && auth.can('SCORE_BDIS')"
  >
    <div class="card-header">
      <h5>Scan code suivi</h5>
    </div>
    <div class="card-body p-15 p-sm-20 p-md-25">
      <form v-on:submit.prevent="SearchColis">
        <div class="custom-search">
          <div class="row">
            <div class="col-md-8">
              <div class="form-group">
                <label>Code Suivi :</label>
                <input
                  placeholder="Code Suivi"
                  type="text"
                  id="scanFocus"
                  v-model="codeColis"
                  class="form-control"
                />
              </div>
            </div>
            <div class="col-md-4">
              <button class="btn btn-success me-3 mb-3 mt-3" type="submit">
                <i class="ph ph-scan"></i>
              </button>
            </div>
            <div class="col-12">
              <hr />
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>

  <div class="card mb-25 border-0 rounded-0 bg-white letter-spacing">
    <div class="card-header">
      <h5 class="card-title">Liste des colis enregistrés</h5>
    </div>

    <div
      class="card-head bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25"
    >
      <div class="d-sm-flex align-items-center">
        <button
          class="default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 bg-danger fs-md-15 fs-lg-16 d-inline-block me-10 mb-10 mb-lg-0"
          type="button"
          v-if="auth.can('ADD_BDIS') && distribution.note_save == 0"
          @click="removeNewColis"
        >
          Supprimer
          <i class="flaticon-delete position-relative ms-5 fs-12"></i>
        </button>
      </div>
      <div class="d-flex align-items-center">
        <input
          type="text"
          @input="getRows1()"
          v-model="users1.searchTerm"
          class="form-control shadow-none text-black rounded-0"
          placeholder="Chercher"
        />
      </div>
    </div>
    <div class="card-body p-15 p-sm-20 p-md-25">
      <vue-good-table
        :columns="columns"
        :rows="rows1"
        :search-options="{
          enabled: true,
          externalQuery: users1.searchTerm,
        }"
        :select-options="{
          selectOnCheckboxOnly: true,
          enabled: true,
          clearSelectionText: 'Annuler',
          selectionText: 'Colis Sélectionés',
          disableSelectInfo: true,
        }"
        @select-all="onSelectAllColis"
        @selected-rows-change="selectionChangedColis"
      >
        <!-- <div slot="emptystate"></div> -->
        <template #emptystate>
          <center>Aucune entrées correspondants trouvés</center>
        </template>
        <template #table-row="props">
          <template v-if="props.column.field === 'code'">
            <h6 class="text-warning" v-if="props.row.replace == 1">
              {{ props.row.code }}
              <i class="flaticon-refresh"></i>
            </h6>
            <h6 class="text-info" v-else-if="props.row.partial == 1">
              {{ props.row.code }}
              <i class="flaticon-corner-down-left"></i>
            </h6>
            <h6 v-else>
              {{ props.row.code }}
            </h6>
          </template>
          <template v-else-if="props.column.field === 'status'">
            <div
              v-if="
                props.row.status == 'IN_PROGRESS' &&
                props.row.status_second &&
                globalStore.globalHelper(props.row.status_second).name
              "
              class="rounded-pill fs-13 badge text-bg-black custom-badge"
              :style="{
                '--dynamic-bg': globalStore.globalHelper(
                  props.row.status_second
                ).code_color,
              }"
            >
              {{ globalStore.globalHelper(props.row.status_second).name }}
            </div>
            <div
              v-else
              class="rounded-pill fs-13 badge text-bg-black custom-badge"
              :style="{ '--dynamic-bg': props.row.code_color }"
            >
              {{ props.row.s_name }}
            </div>
          </template>
          <template v-else-if="props.column.field === 'received_time'">
            <span class="text-nowrap">
              {{ getDate(props.row.received_time) }}
            </span>
          </template>

          <span v-else>
            {{ props.formattedRow[props.column.field] }}
          </span>
        </template>
      </vue-good-table>
      <div class="row">
        <div class="col-12" md="6">
          <div>
            <div class="col-12" md="6">
              <PaginatorContent
                :pagination="users1"
                :offset="9"
                @paginate="getRows1"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script  lang="ts">
import { ref, reactive, onMounted } from "vue";
import moment from "moment";
import api from "@/utils/axios";
import { useAppToast } from "@/composables/useAppToast";
import { useGlobalStore } from "@/stores/global";
import { useAuthStore } from "@/stores/auth";

export default {
  name: "ShowEditBn",

  props: {
    rowBE: {
      type: String,
      // required: true,
    },
    getRecords: {
      type: Function,
    },
    isOpen: {
      type: Boolean,
    },
  },

  setup: (props) => {
    // State
    const isLoader = ref(true);
    const DetailsColis = ref<any[]>([]);
    const CitiesList = ref<any[]>([]);
    const AgenciesList = ref<any[]>([]);
    const searchTerm1 = ref("");
    const searchTerm2 = ref("");
    const pageLength = ref(10);
    const pageLength2 = ref(10);

    const { showToast } = useAppToast();
    const auth = useAuthStore();
    const user = auth.user;

    const columns = [
      {
        label: "Code Suivi",
        field: "code",
      },
      {
        label: "Client",
        field: "customer_name",
      },
      {
        label: "Date de réception",
        field: "received_time",
      },
      {
        label: "Ville",
        field: "city_name",
      },
      {
        label: "Adresse",
        field: "address",
      },
      {
        label: "Commentaire",
        field: "note",
      },
      {
        label: "Prix",
        field: "price",
      },
      {
        label: "Statut",
        field: "status",
      },
    ];

    const columns2 = [
      {
        label: "Code Suivi",
        field: "code",
      },
      {
        label: "Client",
        field: "customer_name",
      },
      {
        label: "Date de réception",
        field: "received_time",
      },
      {
        label: "Ville",
        field: "city_name",
      },
      {
        label: "Adresse",
        field: "address",
      },
      {
        label: "Commentaire",
        field: "note",
      },
      {
        label: "Prix",
        field: "price",
      },
      {
        label: "Statut",
        field: "c_statut",
      },
      {
        label: "Statut Actuel",
        field: "actual_statut",
      },
    ];

    const fields = [
      { key: "parcel_code", label: "Code d'envoi" },
      { key: "situation", label: "Etat" },
      { key: "s_name", label: "Status" },
      { key: "created_at", label: "Date", tdClass: "browserclass" },
      { key: "city_name", label: "Informations" },
      { key: "name", label: "Action par" },
    ];

    const selectedRows = ref<any[]>([]);
    const selectedNewRows = ref<any[]>([]);
    const codeColis = ref("");
    const rows1 = ref<any[]>([]);
    const rows2 = ref<any[]>([]);
    const distribution = ref<any>({});
    const ColiDetails = ref<any>({});
    const city = reactive({ id: 0, name: null as string | null });
    const rowID = ref<number | null>(null);
    const row = ref<any>({});

    const globalStore = useGlobalStore();

    // Pagination state
    const users1 = reactive({
      searchTerm: "",
      total: 0,
      per_page: 10,
      from: 1,
      to: 0,
      current_page: 1,
    });
    const users2 = reactive({
      searchTerm: "",
      total: 0,
      per_page: 10,
      from: 1,
      to: 0,
      current_page: 1,
    });

    // Form state
    const form = reactive({
      id: 0,
      code: "",
      price: "",
      phone: "",
      delivered_fees: "",
      returned_fees: "",
      refused_fees: "",
      receiver: "",
      address: "",
      note: "",
    });

    // Helpers
    function getDate(value: string) {
      return moment.utc(String(value)).format("YYYY-MM-DD HH:mm");
    }

    function resolveUserStatusVariant(status: string) {
      if (status === "PICKED_UP") return "warning";
      if (status === "DELIVERED") return "success";
      if (status === "PAID") return "info";
      if (status === "NOT_PAID") return "danger";
      return "primary";
    }

    // Selection handlers
    function onSelectAll(params: any) {
      selectedRows.value = params.selectedRows;
    }
    function selectionChanged(params: any) {
      selectedRows.value = params.selectedRows;
    }
    function onSelectAllColis(params: any) {
      selectedNewRows.value = params.selectedRows;
    }
    function selectionChangedColis(params: any) {
      selectedNewRows.value = params.selectedRows;
    }

    // API calls
    async function getData() {
      isLoader.value = true;
      try {
        const res = await api.get(`/api/auth/show_bon_distr`, {
          params: { ref: props.rowBE },
        });
        distribution.value = res.data;
        await getRows1();
        await getRows2();
      } finally {
        isLoader.value = false;
      }
    }

    async function getRows1(page = 1) {
      users1.current_page = page;
      const res = await api.get(
        `/api/auth/ListColisSavedDistr?searchTerm=${users1.searchTerm}&page=${users1.current_page}&per_page=${users1.per_page}`,
        { params: { ref: props.rowBE } }
      );
      rows1.value = res.data.users.data;
      Object.assign(users1, res.data.users);
    }

    async function getRows2(page = 1) {
      users2.current_page = page;
      const res = await api.get(
        `/api/auth/ListColiNoSaveDist?searchTerm=${users2.searchTerm}&page=${users2.current_page}&per_page=${users2.per_page}`,
        { params: { ref: props.rowBE } }
      );
      rows2.value = res.data.users.data;
      Object.assign(users2, res.data.users);
    }

    async function SearchColis() {
      let data = new FormData();
      data.append("note_ref", props.rowBE);
      data.append("code_colis", codeColis.value);
      data.append("UserID", user?.id);

      try {
        const res = await api.post(`/api/auth/SaveColisInDistr`, data);
        codeColis.value = "";

        if (res.data.success) {
          const audio = new Audio("/sound.mp3");
          audio.play();
          showToast("Colis ajouté avec succès", "success");

          document.getElementById("scanFocus")?.focus();
          getRows1();
          getRows2();
          props.getRecords();
        } else {
          // The API returns a French message explaining the refusal.
          const audio = new Audio("/erro.mp3");
          audio.play();
          showToast(res.data.message || "Vous ne pouvez pas ajouter ce colis", "error");
        }
      } catch {
        showToast("Something went wrong! Veuillez réessayer", "error");
      }
    }

    // Lifecycle
    onMounted(async () => {
      // const citiesRes = await api.get(`/api/auth/citiesList`);
      // CitiesList.value = citiesRes.data;

      // const agenciesRes = await api.get(`/api/auth/agency_list`);
      // AgenciesList.value = agenciesRes.data;

      if (props.isOpen) {
        await getData();
      }
    });

    async function removeNewColis() {
      try {
        if (!selectedNewRows.value.length) {
          // show toast if no selection
          showToast("Veuillez sélectionner des lignes", "error");
          return;
        }

        const data = new FormData();
        data.append("colis", JSON.stringify(selectedNewRows.value));
        data.append("note_ref", props.rowBE);

        const res = await api.post(`/api/auth/RemoveSavedColisDistr`, data);

        if (res.data.message === "success") {
          const audio = new Audio("/src/assets/sound.mp3");
          audio.play();

          showToast("Supprimées avec succès", "success");
          getData(); // refresh table data
        } else {
          const audio = new Audio("/src/assets/erro.mp3");
          audio.play();
          showToast("Une erreur est survenue, veuillez réessayer", "error");
        }
      } catch (error) {
        console.error(error);
        showToast("Une erreur est survenue, veuillez réessayer", "error");
      }
    }

    return {
      isLoader,
      DetailsColis,
      CitiesList,
      AgenciesList,
      searchTerm1,
      searchTerm2,
      pageLength,
      pageLength2,
      columns,
      columns2,
      fields,
      selectedRows,
      selectedNewRows,
      codeColis,
      rows1,
      rows2,
      distribution,
      ColiDetails,
      city,
      rowID,
      row,
      users1,
      users2,
      form,
      getDate,
      resolveUserStatusVariant,
      onSelectAll,
      selectionChanged,
      onSelectAllColis,
      selectionChangedColis,
      getData,
      getRows1,
      getRows2,
      SearchColis,
      globalStore,
      removeNewColis,
      auth,
    };
  },
};
</script>
